import React, { useState, useEffect } from "react";
import { Col, Row } from "../common";
import { Button, Spin } from "antd";
import ReactQuill from "react-quill";
import {
  createLoadingSelector,
  getGeneralInformation,
  updateGeneralInformation,
  resetStoreState,
} from "../../redux/action";
import { serverApis } from "../../constants/server-apis";
import { useDispatch, useSelector, connect } from "react-redux";
import { isObjectNotEmpty } from "../../common/utils";
import { showAlert } from "../../common/alert-messages";
import { useLocation } from "react-router-dom";

const fullToolbarOptions = {
  toolbar: [
    [{ font: [] }, { size: [] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ align: [] }],
    ["blockquote", "code-block"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image", "video"],
    ["clean"],
  ],
};

const screenInfo = {
  "general-info": { title: "GENERAL INFORMATION", apiKey: "general_info" },
  "terms": { title: "TERMS", apiKey: "terms" },
  "privacy-policy": { title: "PRIVACY POLICY", apiKey: "privacy_policy" },
};

const GeneralInfo = () => {
  const [value, setValue] = useState("");
  const dispatch = useDispatch();
  const location = useLocation();

  const pathKey = location.pathname.split("/").pop(); 
  const screen = screenInfo[pathKey];
  const { title, apiKey } = screen;

  const isFetchingData = useSelector(loadingSelector);
  const generalInformation = useSelector((state) => state.generalInformation);
  const updateMessage = useSelector(
    (state) => state.updateGeneralInformationMessage
  );

  useEffect(() => {
    if (apiKey) {
      dispatch(getGeneralInformation(apiKey));
    }
  }, [apiKey]);

  useEffect(() => {
    if (isObjectNotEmpty(generalInformation)) {
      setValue(generalInformation);
    }
  }, [generalInformation, apiKey]);

  useEffect(() => {
    if (isObjectNotEmpty(updateMessage)) {
      showAlert.success(updateMessage);
      dispatch(resetStoreState(serverApis.updateGeneralInfo.actionName));
      dispatch(getGeneralInformation(apiKey));
    }
  }, [updateMessage, apiKey]);

  const handleSave = () => {
    if (apiKey) dispatch(updateGeneralInformation(value, apiKey));
  };

  const handleReset = () => {
    setValue(generalInformation);
  };

  return (
    <div className="right-wrapper">
      <Spin spinning={isFetchingData} size="large">
        <div className="right-wrapper-inner">
          <Row>
            <Col sm="6">
              <h3 className="panel-title">{title}</h3>
            </Col>
            <Col sm="6" className="text-right">
              <Button
                className="btn-white btn-md radius mr-3"
                onClick={handleReset}
              >
                Reset
              </Button>
              <Button
                className="btn-success btn-md radius"
                onClick={handleSave}
              >
                Save Changes
              </Button>
            </Col>
          </Row>

          <div className="card-box">
            <div className="card-body">
              <ReactQuill
                value={value}
                onChange={setValue}
                modules={fullToolbarOptions}
              />
            </div>
          </div>
        </div>
      </Spin>
    </div>
  );
};

const loadingSelector = createLoadingSelector([
  serverApis.getGeneralInfo.actionName,
  serverApis.updateGeneralInfo.actionName,
]);

const mapStateToProps = (state) => ({
  isFetchingData: loadingSelector(state),
  generalInformation: state.generalInformation,
  updateGeneralInformationMessage: state.updateGeneralInformationMessage,
});

export default connect(mapStateToProps, {
  resetStoreState,
  getGeneralInformation,
  updateGeneralInformation,
})(GeneralInfo);
